import React from "react";
import { Box, Typography } from "@mui/material";
import { QUIZ } from "@/theme/quizTokens";

export type DogDailyNeed = {
    dogId: string;
    dogName: string;
    dailyGrams: number;
    packSize: number;
    recipeCount: number;
};

type Props = {
    dogsData: DogDailyNeed[];
};

export default function PlanDailyNeedStrip({ dogsData }: Props) {
    const rows = dogsData.filter((d) => d.dailyGrams && d.packSize);
    if (!rows.length) return null;

    return (
        <Box
            sx={{
                maxWidth: { xs: "100%", sm: 520, md: 700 },
                mx: "auto",
                mt: { xs: "16px", md: "20px" },
                bgcolor: QUIZ.color.cream2,
                borderRadius: "24px",
                p: { xs: "24px 20px", md: "32px 36px" },
            }}
        >
            {rows.map((dog, i) => (
                <Box key={dog.dogId} sx={{ mt: i === 0 ? 0 : { xs: "20px", md: "24px" } }}>
                    <Typography
                        sx={{
                            fontFamily: QUIZ.font.display,
                            fontWeight: 900,
                            textTransform: "uppercase",
                            color: QUIZ.color.ink,
                            fontSize: { xs: 22, md: 26 },
                            lineHeight: 1.2,
                            mb: "12px",
                        }}
                    >
                        {dog.dogName} needs {dog.dailyGrams}g of fresh food per day
                    </Typography>
                    <Typography
                        sx={{
                            fontFamily: QUIZ.font.body,
                            fontSize: { xs: 15, md: 16 },
                            lineHeight: 1.45,
                            color: QUIZ.color.ink,
                            opacity: 0.85,
                        }}
                    >
                        Packed in {dog.packSize}g recyclable tubs, with {dog.recipeCount} different{" "}
                        {dog.recipeCount === 1 ? "recipe" : "recipes"} to choose from at the next step.
                    </Typography>
                </Box>
            ))}
        </Box>
    );
}